// extracted by mini-css-extract-plugin
export default {"ItemFormModal":"ItemFormModal_ItemFormModal__72mQJ"};